export default {
  BT_HDP: "让球",
  BT_OU: "大/小",
  BT_ML: "胜负盘",
  BT_1X2: "独赢",
  BT_1X2HDP: "三项让分投注",
  BT_CS: "波胆",
  BT_OE: "单/双",
  BT_DC: "双重机会",
  BT_HTFT: "半场/全场",
  BT_FGLG: "最先进球/最后进球",
  BT_TG: "总进球",
  BT_OR: "优胜冠军",
  BT_ORZ: "优胜冠军",

  BT_ANB: "客场无效",
  BT_BS: "双方/一方/两者皆不得分",
  BT_CL: "零失球",
  BT_DNB: "获胜球队",
  BT_DNBH: "上半场获胜球队",
  BT_HNB: "主场无效",
  BT_TWTN: "零失球的胜方",

  BT_HDPF: "全场让球",
  BT_OUF: "全场大",
  BT_MLF: "全场胜负盘",
  BT_1X2F: "全场独赢",
  BT_1X2HDPF: "全场三项让分投注",
  BT_CSF: "全场波胆",
  BT_OEF: "全场单",
  BT_DCF: "全场双重机会",
  BT_FGLGF: "全场最先进球/最后进球",
  BT_TGF: "全场总进球",

  BT_HDPH: "上半场让球",
  BT_OUH: "上半场大/小",
  BT_MLH: "上半场胜负盘",
  BT_1X2H: "上半场独赢",
  BT_1X2HDPH: "上半场三项让分投注",
  BT_CSH: "上半场波胆",
  BT_OEH: "上半场单/双",
  BT_DCH: "上半场双重机会",
  BT_FGLGH: "上半场最先进球/最后进球",
  BT_TGH: "上半场总进球",
  BT_O: "大",
  BT_U: "小",

  BT_HDPOU: "让球&大小",
  BT_PARLAY: "混合过关",
  BT_FT: "全场",
  BT_1H: "上半场",
  BT_2H: "下半场",

  BT_FG: "最先进球",
  BT_LG: "最后进球",
  BT_HFG: "主先",
  BT_AFG: "客先",
  BT_HLG: "主后",
  BT_ALG: "客后",
  BT_NG: "无进球",
  BT_HY: "主是",
  BT_HN: "主否",
  BT_AY: "客是",
  BT_AN: "客否",

  BT_HD_DC: "主 或 和局",
  BT_HA_DC: "主 或 客",
  BT_DA_DC: "客 或 和局",
  BT_HH: "主主",
  BT_HD: "主和",
  BT_HA: "主客",
  BT_DH: "和主",
  BT_DD: "和和",
  BT_DA: "和客",
  BT_AH: "客主",
  BT_AD: "客和",
  BT_AA: "客客",

  BT_H: "主",
  BT_A: "客",
  BT_D: "和局",

  BT_Y: "是",
  BT_N: "否",

  BT_LIVE: "滚球",
  BT_HT: "半场",
  BT_DELAYED: "延迟",
  BT_PEN: "点球",

  BT_FT1: "全场.1",
  BT_FT2: "全场.2",
  BT_FTX: "全场.X",

  BT_HT1: "半场.1",
  BT_HT2: "半场.2",
  BT_HTX: "半场.X",

  BS_HDP: "全场让球",
  BS_HDPH: "上半场让球",
  BS_OU: "全场大/小",
  BS_OUH: "上半场大/小",
  BS_OE: "全场单/双",
  BS_OEH: "上半场单/双",
  BS_1X2: "全场1X2",
  BS_1X2H: "上半场1X2",
  BS_ML: "全场独赢",
  BS_MLH: "上半场独赢",
  BS_1X2HDP: "全场三项让分投注",
  BS_1X2HDPH: "上半场三项让分投注",
  BS_CS: "全场波胆",
  BS_CSH: "上半场波胆",
  BS_DC: "全场双重机会",
  BS_DCH: "上半场双重机会",
  BS_FGLG: "全场最先进球/最后进球",
  BS_FGLGH: "上半场最先进球/最后进球",
  BS_TG: "全场总进球",
  BS_TGH: "上半场总进球",
  BS_ANB: "客场无效",
  BS_HTFT: "半场/全场",
  BS_BS: "双方/一方/两者皆不得分",
  BS_CL: "零失球",
  BS_DNB: "获胜球队",
  BS_DNBH: "上半场获胜球队",
  BS_HNB: "主场无效",
  BS_TWTN: "零失球的胜方",
  BS_OR: "优胜冠军",
  BS_ORZ: "优胜冠军",

  LOT_BS: "大/小",
  LOT_BIG: "大",
  LOT_SMALL: "小",
  LOT_OE: "单/双",
  LOT_ODD: "单",
  LOT_EVEN: "双",
  LOT_OU: "大/小",
  LOT_OVER: "大",
  LOT_UNDER: "小",
  LOT_FT: "全场",
  LOT_HT: "半场",

  BT_ALLBT: "所有投注类型",
  D_1: "正字",
  D_2: "正字与反字",
  D_3: "包字",
  D_4: "全保",
  D_5: "包字最后3个号码",
  D_6: "包字最后2个号码",

  D_BIG: "大",
  D_SMALL: "小",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "主",
  LOT_0: "客",

  BT_KO: "取胜方式",

  ODD_Home: "主",
  ODD_Away: "客",
  ODD_Draw: "和",
  ODD_Over: "大",
  ODD_Under: "小",
  ODD_Odd: "单",
  ODD_Even: "双",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "OVER (4,5,6)",
  GH_UNDER: "UNDER (1,2,3)",
  GH_ODD: "ODD (1,3,5)",
  GH_EVEN: "EVEN (2,4,6)",
  GH_OU1: "OVER (4,5,6)",
  GH_OU2: "UNDER (1,2,3)",
  GH_OE1: "ODD (1,3,5)",
  GH_OE2: "EVEN (2,4,6)",

  GX_1X2: "WIN",
  GX_1X20: "WIN",
  GX_1X2HDP: "PLACE/SHOW",
  GX_1X2HDP2: "PLACE",
  GX_1X2HDP4: "SHOW",
  GX_OVER: "OVER (7-12)",
  GX_UNDER: "UNDER (1-6)",
  GX_ODD: "ODD (1,3,5,7,9,11)",
  GX_EVEN: "EVEN (2,4,6,8,10,12)",
  GX_OU1: "OVER (7-12)",
  GX_OU2: "UNDER (1-6)",
  GX_OE1: "ODD (1,3,5,7,9,11)",
  GX_OE2: "EVEN (2,4,6,8,10,12)",

  ROOM_A: "开放",
  ROOM_0: "活跃",
  ROOM_1: "关闭",
  ROOM_2: "取消",
  ROOM_3: "结束",
  ROOM_4: "停止投注",
  ROOM_10: "全部",

  ROOM_T0: "全部",
  ROOM_T1: "公共房间",
  ROOM_T2: "私人房间",
  ROOM_T3: "玩游戏赚钱",

  joinRoom1: "加入公共房间",
  joinRoom2: "加入私人房间",
  joinRoom3: "加入游戏房间",
  createRoom1: "创建公共房间",
  createRoom2: "创建私人房间",
  createRoom3: "创建游戏房间",
  Champion: "冠军",
  FirstRunnerUp: "亚军",
  SecondRunnerUp: "季军",

  BT_OEHM: "Home Odd/Even | Home O/E",
  BT_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BT_OEAW: "Away Odd/Even | Away O/E",
  BT_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  BS_OEHM: "FT. Home Odd/Even | FT. Home O/E",
  BS_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BS_OEAW: "FT. Away Odd/Even | FT. Away O/E",
  BS_OEAWH: "FH. Away Odd/Even | FH. Away O/E",
  
  MB_OVER: "OVER (4,5,6)",
  MB_UNDER: "UNDER (1,2,3)",
  MB_ODD: "ODD (1,3,5)",
  MB_EVEN: "EVEN (2,4,6)",
};